import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import NetworkRequest from "../../../config/network";
import configuration from "../../../config/configuration";

export const fetchTenantsList = createAsyncThunk(
  "getAllTenantsList ",
  async () => {
    try {
      // const response = await NetworkRequest.get(
      //   configuration.apis.getAllTenants,
      // );
      // if (response?.data?.status === true) {
      //   const resultData = response.data.data;
      //   const getAllTenantsResult = Object.entries(resultData).map(
      //     ([label, value]) => ({
      //       value,
      //       label,
      //     }),
      //   );
      //   return getAllTenantsResult;
      // }
    } catch (err) {
      console.log(err);
    }
  },
);

interface TenantsState {
  tenant: any;
  loading: boolean;
  error: any;
}

const initialState = {
  tenant: {},
  loading: false,
  error: {},
} satisfies TenantsState as TenantsState;

const tenantsSlice = createSlice({
  name: "tenant",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTenantsList.pending, (state, action) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchTenantsList.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
        state.tenant = action.payload;
      })
      .addCase(fetchTenantsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.tenant = {};
      });
  },
});

export default tenantsSlice.reducer;
